module.exports = __webpack_public_path__ + "media/hyper/images/attached-files/img-1-c7a4dc340d03cf0506f9ac687fab0b2c.jpg";